import { isHeiDomain } from 'app/utils/heiDomain';

// Hostname never changes during SPA lifecycle — compute once at module level.
const isHei = typeof window !== 'undefined' ? isHeiDomain(window.location.hostname) : false;

export const useIsHeiDomain = (): boolean => isHei;
